import { CommunityQuestionPicker } from "../../../pickers/community-question/CommunityQuestionPicker";
import { SuccessStoryPicker } from "../../../pickers/success-story/SuccessStoryPicker";
import type { SuccessStory } from "../../../types/success-stories";
import type { CommunityQuestionBase } from "../../Community/types/community-questions";
import { SettingCard } from "../components/SettingCard";
import { settingsService } from "../services/settingsService";
import type { SettingsTabProps } from "./settingsTabTypes";

export const CommunitySettingsTab = ({ settings, onSettingsChange }: SettingsTabProps) => {
  const handleUpdateCommunityFeaturedQuestion = async (question: CommunityQuestionBase | null) => {
    const questionId = question?.id ?? '';
    await settingsService.updateCommunityFeaturedQuestion(questionId);
    onSettingsChange({ communityFeaturedQuestion: questionId });
  };

  const handleUpdateCommunityFeaturedSuccessStory = async (successStory: SuccessStory | null) => {
    const successStoryId = successStory?.id ?? '';
    await settingsService.updateCommunityFeaturedSuccessStory(successStoryId);
    onSettingsChange({ communityFeaturedSuccessStory: successStoryId });
  };

  return (
    <>
      <SettingCard title="Community Featured Question">
        <CommunityQuestionPicker value={settings.communityFeaturedQuestion} onChange={handleUpdateCommunityFeaturedQuestion} />
      </SettingCard>
      <SettingCard title="Community Featured Success Story">
        <SuccessStoryPicker value={settings.communityFeaturedSuccessStory} onChange={handleUpdateCommunityFeaturedSuccessStory} />
      </SettingCard>
    </>
  );
};
